import type { VaultEnvelope } from './core'

const DATABASE = 'pass-creator'
const STORE = 'vault'
const KEY = 'current'

function openDatabase(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DATABASE, 1)
    request.onupgradeneeded = () => request.result.createObjectStore(STORE)
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
}

async function transact<T>(mode: IDBTransactionMode, run: (store: IDBObjectStore) => IDBRequest<T>) {
  const database = await openDatabase()
  try {
    return await new Promise<T>((resolve, reject) => {
      const transaction = database.transaction(STORE, mode)
      const request = run(transaction.objectStore(STORE))
      request.onsuccess = () => resolve(request.result)
      request.onerror = () => reject(request.error)
      transaction.onerror = () => reject(transaction.error)
    })
  } finally {
    database.close()
  }
}

export function loadEnvelope() {
  return transact<VaultEnvelope | undefined>('readonly', (store) => store.get(KEY))
}

export function saveEnvelope(envelope: VaultEnvelope) {
  return transact<IDBValidKey>('readwrite', (store) => store.put(envelope, KEY))
}
